import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import {faInsider} from "../components/CustomIcons/faInsider";

export const insiderIcon: FontAwesomeIconProps = {icon: faInsider};

